import {Component, inject, OnInit} from "@angular/core";
import {ModelStore} from "../../../core/model-store/model-store";
import {MatCheckboxChange} from "@angular/material/checkbox";

@Component({
    selector: 'report-templates',
    templateUrl: './report-templates.component.html',
    styleUrls: ['./report-templates.component.scss'],
    standalone: false
})
export class ReportTemplatesComponent implements OnInit {
  // Injections
  private readonly modelStore: ModelStore = inject(ModelStore);

  reportTemplates: any;
  selectedTemplates: string[] = [];

  constructor() {
    this.deleteTemplates = this.deleteTemplates.bind(this);
  }

  ngOnInit() {
    this.asyncInit().then();
  }

  async asyncInit() {
    this.reportTemplates = this.modelStore.findAllModels('report_user_template')
    await this.reportTemplates.loading;

    let reportViewTypes = this.modelStore.findAllModels('report_view_type');
    await reportViewTypes.loading;

    if (this.reportTemplates.length > 0) {
      this.reportTemplates.forEach(async template => {
        if (template.reportViewTypeId) {
          template.reportViewType = await this.modelStore.findModel('report_view_type', template.reportViewTypeId);
        }
      });
    }
  }

  async deleteTemplates() {
    if (this.selectedTemplates.length > 0) {
      for (const reportId of this.selectedTemplates) {
        let deletedModel =  this.modelStore.deleteModel('report_user_template', reportId);
        await deletedModel.loading;
      }

      this.reportTemplates = this.modelStore.findAllModels('report_user_template')
    }
    console.log('DELETE TEMPLATES: ', this.selectedTemplates);
  }

  templateSelectionChanged(event: MatCheckboxChange, templateId : string) {
    if (event.checked && !this.selectedTemplates.includes(templateId)) {
      this.selectedTemplates.push(templateId);
    } else if (!event.checked && this.selectedTemplates.includes(templateId)) {
      this.selectedTemplates.splice(this.selectedTemplates.indexOf(templateId), 1);
    }
  }
}
